/* KORE Process — «Mucho más que ropa personalizada»
   (sections/kore-process.liquid).

   Elige qué paso cuenta la escena y lleva el cabezal de luz del riel.

   - Anclada (kore-scrolly puso .kore-pin--on): manda el avance del
     anclaje. Los cinco pasos se reparten el recorrido y el último 10 %
     es un respiro para que la entrega se asiente antes de soltar.
   - Sin anclar (móvil, ventanas bajas, movimiento reducido): manda una
     línea de lectura. En móvil el objeto va pegado arriba, así que la
     línea baja para quedar por debajo de él.

   El relieve, la entrada y la inclinación al ratón son de
   assets/kore-stage3d.js; aquí solo se cambia data-kpr-on. */
(function () {
  'use strict';
  if (window.KoreProcess) return;
  window.KoreProcess = true;

  var estrecho = window.matchMedia('(max-width: 900px)');
  var units = [];
  var raf = 0;
  var hasta = 0;

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }

  function setup() {
    units = [];
    Array.prototype.forEach.call(document.querySelectorAll('[data-kpr]'), function (root) {
      var list = root.querySelector('[data-kpr-steps]');
      var steps = Array.prototype.slice.call(root.querySelectorAll('[data-kpr-step]'));
      if (!list || !steps.length) return;
      root.classList.add('kpr--live');
      units.push({
        root: root,
        wrap: root.closest('[data-kore-pin]'),
        list: list,
        steps: steps,
        dots: steps.map(function (s) { return s.querySelector('[data-kpr-dot]') || s; }),
        last: -1
      });
    });
    update();
  }

  /* Centro vertical del número de cada paso, relativo a la lista. */
  function centros(u) {
    var top = u.list.getBoundingClientRect().top;
    return u.dots.map(function (d) {
      var r = d.getBoundingClientRect();
      return r.top + r.height / 2 - top;
    });
  }

  function update() {
    raf = 0;
    var vh = window.innerHeight || 1;
    for (var n = 0; n < units.length; n++) {
      var u = units[n];
      var c = centros(u);
      var total = u.steps.length;
      var idx, y;

      if (u.wrap && u.wrap.classList.contains('kore-pin--on')) {
        var len = Math.max(1, u.wrap.offsetHeight - vh);
        var q = clamp(-u.wrap.getBoundingClientRect().top / len / 0.9, 0, 1);
        var f = Math.min(q * total, total - 0.0001);
        idx = Math.floor(f);
        /* El cabezal se desliza de un número al siguiente mientras dura el
           paso, y se para en el último. */
        y = idx < total - 1 ? c[idx] + (c[idx + 1] - c[idx]) * (f - idx) : c[idx];
      } else {
        var linea = vh * (estrecho.matches ? 0.68 : 0.55) - u.list.getBoundingClientRect().top;
        idx = 0;
        for (var i = 0; i < total; i++) if (c[i] <= linea) idx = i;
        y = clamp(linea, c[0], c[total - 1]);
      }

      u.root.style.setProperty('--kpr-y', y.toFixed(1) + 'px');
      if (idx === u.last) continue;
      u.last = idx;
      u.root.setAttribute('data-kpr-on', String(idx));
      for (var k = 0; k < total; k++) {
        u.steps[k].classList.toggle('is-on', k === idx);
        u.steps[k].classList.toggle('is-past', k < idx);
      }
      /* Al cambiar de paso, el texto se despliega y los números se mueven:
         el cabezal los sigue mientras dura el despliegue. */
      hasta = performance.now() + 650;
      seguir();
    }
  }

  function seguir() {
    if (performance.now() > hasta) return;
    requestAnimationFrame(function () { update(); seguir(); });
  }

  function onScroll() {
    if (!raf && units.length) raf = requestAnimationFrame(update);
  }

  /* kore-scrolly decide el anclaje en load y en resize; se mide después. */
  function despues() { setTimeout(onScroll, 220); }

  document.addEventListener('scroll', onScroll, { capture: true, passive: true });
  window.addEventListener('resize', despues);
  window.addEventListener('load', despues);
  document.addEventListener('shopify:section:load', function () { setup(); despues(); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
